import {type RestTypeWithTypename} from '../rest-type-with-typename';
import type {CreateBillingPlanMutationData} from './create-billing-plan';

export function createBillingPlanPatcher(
    data: CreateBillingPlanMutationData,
): RestTypeWithTypename<CreateBillingPlanMutationData> {
    return {
        __typename: 'CreateBillingPlanMutation',
        plan: {
            __typename: 'Plan',
            ...data.plan,
            sessionBookings: data.plan.sessionBookings.map(sessionBooking => ({
                ...sessionBooking,
                __typename: 'SessionBooking',
                monthlyPrices: sessionBooking.monthlyPrices.map(monthlyPrice => ({
                    ...monthlyPrice,
                    __typename: 'MonthlyPrice',
                })),
            })),
            productBookings: data.plan.productBookings.map(productBooking => ({
                ...productBooking,
                __typename: 'ProductBooking',
            })),
        },
    };
}
